import React, { useEffect } from "react";
import Link from "next/link";
import { logout } from "../../utils/auth";
import { OutlineButton } from "../Button";
import { HOST_BASE_URL, MERCHANT_BASE_URL } from "../../utils/constants";
import { useUser } from "../../utils/UserContext";
import { useAdminLayoutContext } from "../../contexts/AdminLayout";

export default () => {
  let { firstname, authenticationType, merchantLogo } = useUser();
  const { openSidebar, setOpenSidebar } = useAdminLayoutContext();
  return (
    <header className="ci-auth-navbar">
      <a
        className="ci-sidenav-toggler"
        role="button"
        onClick={() => setOpenSidebar(!openSidebar)}
      >
        <i className="fas fa-bars"></i>
      </a>
      <Link
        href={authenticationType === "HOST" ? HOST_BASE_URL : MERCHANT_BASE_URL}
      >
        <a className="ci-logo-brand">
          <span>1Government Cloud</span>
          <span>Admin</span>
        </a>
      </Link>
      <nav className="ci-nav" role="">
        <ul className="ci-navbar">
          <li className="dropdown">
            <a
              href="#"
              className="dropdown-toggle ci-nav-user"
              data-bs-toggle="dropdown"
            >
              <img
                src={merchantLogo ? merchantLogo : "/static/img/1Gov/Profile.svg"}
                className=""
                alt="User Image"
              />
              <span className="">{firstname}</span>
              {/* <i className="fas fa-sort-down "></i> */}
            </a>
            <ul className="dropdown-menu auth-nav-menu">
              <li className="dropdown-item">
                {/* {authenticationType === "MERCHANT" && ( */}
                {/* <Link href={`${MERCHANT_BASE_URL}/administration`}> */}
                
                <Link href={`${MERCHANT_BASE_URL}/administration`}> 
                  <a>Profile</a>
                </Link>
                {/* )} */}
              </li>
              <li className="dropdown-item">
                {/* {authenticationType === "MERCHANT" && ( */}
                {/* <Link href={`${MERCHANT_BASE_URL}/administration`}> */}
                <Link href='#'>
                  <a className="text-red clearfix" onClick={logout}>Logout <i className="fas fa-sign-out-alt pull-right text-red"></i></a>
                </Link>
                {/* )} */}
              </li>
              {/* <li className="">
                <Link>
                <a  className="text-red" >
                  <span className="pull-left">Logout</span>
                  <i className="fas fa-sign-out-alt pull-right text-red"></i>
                </a>
                </Link>
              </li> */}
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
};
